import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import PaymentPlanReviewModal from "./PaymentPlanReviewModal";
import { getOfferDisclaimer, getVehicle, getVehiclePrice } from "src/store/selectors/vehicles";
import { getAccountCountry } from "src/store/selectors/account";

function mapStateToProps(state: ApplicationStore) {
    const vin = state.currentDeal.vin as string;

    return {
        account: state.account,
        deal: state.deal,
        disclaimerText: getOfferDisclaimer(state, vin),
        region: getAccountCountry(state),
        tradePending: state.tradeIn,
        vehicle: getVehicle(state, vin),
        vehiclePrice: getVehiclePrice(state, vin),
        offerIndex: state.onlineShopper.subModal.bankOfferId,
    };
}

export default connect(mapStateToProps)(PaymentPlanReviewModal);
